export function truncate(text: string, length: number) {
  return `${text.substring(0, length)}…`
}

export function truncateBeginning(text: string, length: number) {
  return `…${text.substring(text.length - length)}`
}
